import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router';

import Button, { ButtonType } from 'components/ui/Button';

const ReviewCheckInButton = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const handleGoToFirstStep = () => {
    // If no step is specified for accessing /checkin,
    // the router will automatically redirect to the first visible step in the check-in flow.
    navigate(`/checkin/${search}`);
  };

  return (
    <Button
      type={ButtonType.SECONDARY}
      onClick={handleGoToFirstStep}
      className="footer-button"
      testId="review-checkin"
    >
      <FormattedMessage
        id="skip.review"
        defaultMessage="Review my check-in"
      />
    </Button>
  );
};

export default ReviewCheckInButton;
